import { getApi } from "./api_instance";

export const getTransactions = async (url, dispatch) => {
  try {
    const { data } = await getApi({
      apiUrl: `/payments/api/wallet/transactions${url}`,
      dispatch,
      sendToken: true,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
